import React, { Component } from 'react';
import PropTypes from 'prop-types';
import translate from 'app/translations';
import {
  Upload, Button, message, Form,
} from 'antd';
import FileUploadService from './FileUploadService';
import fileUtils from '../utils/fileUtils';

const FormItem = Form.Item;

class FileUpload extends Component {
  static propTypes = {
    showSubmitButton: PropTypes.bool,
    required: PropTypes.bool,
    displayName: PropTypes.string,
    errorMsg: PropTypes.string,
    isSubmitted: PropTypes.bool,
    docType: PropTypes.string,
    metaData: PropTypes.object,
    endpoint: PropTypes.string.isRequired,
    accept: PropTypes.string,
  };

  static defaultProps = {
    showSubmitButton: false,
    required: false,
    displayName: '',
    errorMsg: '',
    isSubmitted: false,
    docType: '',
    metaData: null,
    accept: undefined,
  }

  constructor() {
    super();
    this.t = translate;
    this.state = {
      fileList: [],
      uploading: false,
    };
    this.validateFiles = this.validateFiles.bind(this);
  }

  getFileTypeErrors(fileList) {
    const errors = [];
    fileList.forEach((file) => {
      const fileExtensionWithDot = `.${fileUtils.getFileExtension(file.name)}`;

      const isValidImage = (fileUtils.isImage(this.props.accept) && fileUtils.isSameType(this.props.accept, file.type));

      if (!isValidImage && fileExtensionWithDot !== this.props.accept) {
        const error = this.t(
          'FormControl.fileUpload.typeError',
          { name: file.name, acceptType: this.props.accept },
        );
        errors.push(error);
      }
    });
    return errors;
  }

  getHelpMsg() {
    const validateFiles = this.validateFiles();
    if (!validateFiles || !this.props.isSubmitted) return '';

    if (validateFiles.required) {
      return this.props.errorMsg;
    } if (validateFiles.fileTypeErr) {
      return validateFiles.fileTypeErr;
    }
    return '';
  }

  handleUpload = async () => {
    const { fileList } = this.state;
    const formData = new FormData();

    if (fileList.length === 0 && this.props.required === false) {
      return new Promise((resolve) => {
        resolve({ data: { documents: [] } });
      });
    }
    if (this.props.metaData) {
      formData.append('docs', JSON.stringify(this.props.metaData));
    }
    fileList.forEach((file) => {
      formData.append('docs', file, file.name);
    });

    this.setState({
      uploading: true,
    });
    const { endpoint } = this.props;
    return FileUploadService.sendPost(endpoint, formData)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        throw new Error(`Error status ${response.status}`);
      })
      .then((responseJson) => {
        message.success(this.t('FormControl.fileUpload.success'));
        return new Promise((resolve) => {
          resolve(responseJson);
        });
      })
      .catch(() => {
        message.error(this.t('FormControl.fileUpload.fail'));
        return new Promise((_, reject) => {
          reject();
        });
      })
      .finally(() => {
        this.setState({
          fileList: [],
          uploading: false,
        });
      });
  }

  mapResponseToDocumentList(response) {
    const { fileList } = this.state;
    const mappedDocs = [];
    fileList.forEach((file, index) => {
      mappedDocs.push({
        docDate: new Date().toJSON(),
        docId: response.data.uploadDocuments[index],
        docName: file.name,
        docType: this.props.docType,
        verified: false,
      });
    });
    return mappedDocs;
  }

  validateFiles() {
    const errors = {};
    if (this.state.fileList.length === 0) {
      errors.required = true;
    }

    if (this.props.accept) {
      const fileTypeErr = this.getFileTypeErrors(this.state.fileList);
      if (fileTypeErr.length > 0) {
        errors.fileTypeErr = fileTypeErr.join(', ');
      }
    }

    return (Object.keys(errors).length > 0) ? errors : undefined;
  }

  render() {
    const { uploading } = this.state;
    const { accept } = this.props;

    const props = {
      accept,
      multiple: false,
      onRemove: (file) => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: (file) => {
        const fileErrors = this.getFileTypeErrors([file]);
        if (fileErrors && fileErrors.length > 0) {
          const errorText = this.t(
            'FormControl.fileUpload.typeError',
            { name: file.name, acceptType: this.props.accept },
          );
          message.error(errorText);
        } else {
          this.setState(() => ({
            fileList: [file],
          }));
        }

        return false;
      },
      fileList: this.state.fileList,
    };

    return (
      <div>
        <FormItem
          validateStatus={(this.validateFiles() && this.props.isSubmitted) ? 'error' : ''}
          required={this.props.required}
          label={this.props.displayName}
          help={this.getHelpMsg()}
          colon={false}
        >
          <Upload {...props} type="drag" multiple={false}>
            <span>{this.t('FormControl.fileUpload.drag')} </span>
            <span>{this.t('FormControl.fileUpload.or')} </span>
            <Button className="inline-block blue-text btn-link">
              {this.t('FormControl.fileUpload.selectFile')}
            </Button>
            <span> {this.t('FormControl.fileUpload.andClick')}</span>
          </Upload>
          {this.props.showSubmitButton && (
            <Button
              style={{ marginTop: 24, marginBottom: 24, padding: 0 }}
              type="primary"
              onClick={this.handleUpload}
              disabled={this.state.fileList.length === 0 || uploading}
              loading={uploading}
            >
              {this.t('FormControl.fileUpload.upload')}
            </Button>
          )}
        </FormItem>
      </div>

    );
  }
}

export default FileUpload;
